import { LayoutType, PageLayouts } from '~/portal/types/layout.ts'

const layouts: PageLayouts = {
  [LayoutType.DEFAULT]: {
    consumerTopBar: {
      search: {
        disabled: true,
      }
    },
    previewTopBar: {
      productContent: {
        disabled: true,
      }
    }
  }
}

export default layouts